import colors from './colors';
export const common = {
  backgroundColor: colors.neutral[100],
  boxShadow: '0 4px 12px 0 rgba(16, 42, 67, 0.2)',
  fontFamily: "'Lato', 'sans-serif'",
};
